import type { DealProviderConfig } from '@openx/components-deal/lib/utils/context/DealContext.tsx';
import { transformOptionsByPath } from '@openx/components-deal/lib/utils/transformOptionsByPath.ts';
import type { Option } from '@openx/types/options.ts';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../../hooks/useOptionsByPathQuery.ts';

export const usePdpSyncNegotiationStatusOptionsFetch: DealProviderConfig['usePdpSyncNegotiationStatusOptionsFetch'] =
  () => {
    const {
      data: { optionsByPath = [] } = {},
      loading,
      refetch,
    } = useOptionsByPathQuery({
      variables: {
        path: 'deal.pdp_deal_negotiation_status_option_enum',
      },
      fetchPolicy: 'network-only',
    });

    const { list, mapById } = useMemo(() => transformOptionsByPath<Option>(optionsByPath), [optionsByPath]);

    return {
      list,
      loading,
      mapById,
      refetch,
    };
  };
